<template>
  <div v-if="separador" class="menu-divider"></div>
  <li class="nav-item" :class="clasesNavItem"> 
    <app-link :to="ruta" class="nav-link" :style="style" :class="{ active: activo }">
      <i v-if="nombre != 'Soporte'" style="float: inline-start; margin-top: 4px;" class="top left nav-icon"
        :class="clasesIcono"></i>
      <i @click.prevent="cambiarparenturl()" v-if="nombre == 'Soporte'" style="float: inline-start; margin-top: 4px;" class="top left nav-icon"
        :class="clasesIcono"></i>
      <p>
        <slot />
      </p>
    </app-link>
  </li>
</template>

<script>
export default {
  props: [
    "ruta",
    "clasesIcono",
    "nombre",
    "clasesNavItem",
    "activo",
    "style",
    "separador"
  ],
  methods: {
      cambiarparenturl(){
      this.$parent.cambiarurl();
      }


    },
};
</script>
<style scoped>
.menu-divider {
    height: 1px;
    background-color: rgba(255, 255, 255, 0.1); /* Color claro para fondos oscuros */
    margin: 10px 0; /* Espacio arriba y abajo */
    border-bottom: 1px solid rgba(0, 0, 0, 0.2); /* Efecto de relieve sutil */
    width: 100%;
    display: block;
}
</style>
